import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 1rem;
  border-top: 1px solid lightgrey;
  margin-top: 5px;
  padding-top: 25px;
  width: 400px;
`;
